import { config } from '../config';

const MEASUREMENT_ID = 'G-S12941XRBB';
const GTAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;

let initialized = false;

export function initGoogleAnalytics(): void {
  if (initialized || !config.features.googleAnalytics) {
    return;
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const dataLayer = window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    // eslint-disable-next-line prefer-rest-params -- Preserve the Google snippet's Arguments queue format.
    dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID);

  if (!document.querySelector(`script[src="${GTAG_SRC}"]`)) {
    const script = document.createElement('script');
    script.src = GTAG_SRC;
    script.async = true;
    document.head.appendChild(script);
  }

  initialized = true;

  if (config.features.debug) {
    console.info('Google Analytics initialized');
  }
}

export type AnalyticsParams = Record<string, string | number | boolean | undefined>;

/**
 * Sends a GA4 event. No-op when Google Analytics is disabled or not initialized,
 * so call sites never need to check the feature flag themselves.
 */
export function trackEvent(name: string, params: AnalyticsParams = {}): void {
  if (!initialized || !window.gtag) {
    return;
  }

  const context = window.location.pathname.startsWith('/embed') ? 'embed' : 'standalone';
  window.gtag('event', name, { context, ...params });

  if (config.features.debug) {
    console.info('GA event', name, params);
  }
}
